/* global app, existingGroups */

app.controller('dialog_editGroupPermissionsCtrl', ['$rootScope', '$scope', '$http', 'NetworkService','AtlasNotification', function ($rootScope, $scope, $http, NetworkService, AtlasNotification) {
        $scope.gui = {okButtonDisabled:true, editview:{show:false}};
        $scope.position = {};
        $scope.existingGroups = existingGroups;
        $scope.selectedGroup = {};
        $scope.selectedPermissionLevel = "";
        
        $scope.searchForUser = function(){
            console.error("This should be implemented as an directive");
            if(!document.querySelector("#searchMenu").classList.contains("mdc-menu-surface--open")){
                 document.querySelector("#searchMenu").classList.add("mdc-menu-surface--open")
             }
        }
        
        $scope.showEditView = function(){
            $scope.gui.editview.show = true;
            /*setTimeout(function(){
                var m = new mdc.menu.MDCMenu(document.querySelector(".mdc-menu"));
                m.setAnchorMargin({top: 24})
                m.open = false;
                m.open = true;
            },200)*/
        }
        
        $scope.addGroup = function(group){
            $scope.searchfield = group.Gruppenname;
            $scope.selectedGroup = group;
        }
        
        $scope.addGroupPermissionToEvent = function(){
            var data = {
                groupId: $scope.selectedGroup.groupId,
                permissionLevel: $scope.selectedPermissionLevel,
                eventId: event.Veranstaltungsnummer
            }
            
            NetworkService.callOperation("addgrouppermissiontoevent", data, function(response){
                AtlasNotification.info("Gruppen-Berechtigung wurde erfolgreich hinzugefügt");
            })
        }
        
        $scope.removeGroupFromEvent = function(group){
            var data = {
                groupId: group.groupId,
                permissionLevel: group.Berechtigungslevel,
                eventId: event.Veranstaltungsnummer
            }
            console.log(group)
            NetworkService.callOperation("removegrouppermissifromtoevent", data, function(response){
                AtlasNotification.info("Gruppen-Berechtigung wurde erfolgreich gelöscht");
            })
        }
        
        $rootScope.$on("editPositionDialog", function(e,data){
            $scope.event = data
        })
    }])